module.exports = __webpack_public_path__ + "static/media/template (2).a740a115.png";